import { decimalToUnits } from '../../amount/money.js';
/** Presentation of an already validated quote; partner is a deprecated ecosystem alias. */
export function hostedQuoteSummary(quote, review) {
    const { currency, decimals, principalUnits } = review.estimate;
    const fees = [];
    for (const kind of ['network', 'ecosystem', 'moonpay']) {
        const fee = quote.fees[kind];
        if (fee)
            fees.push({ kind, units: decimalToUnits(fee.amount, decimals).toString() });
    }
    return {
        currency,
        decimals,
        payUnits: decimalToUnits(quote.source.amount, decimals).toString(),
        principalUnits,
        asset: quote.destination.asset.code === 'USDC_SOL' ? 'USDC' : quote.destination.asset.code,
        receivedAmount: quote.destination.amount,
        exchangeRate: quote.exchangeRate,
        fees,
    };
}
